import { dashboardService } from "@/api/services/dashboardService";
import { DashboardApiTrendWidget } from "../dashboardLeafWidgets";

type Data = Record<string, any>;

/** 新增会员费用分析，保留三类会员费用趋势。 */
export default function AddMemberRevenueAnalysis() {
    return (
        <DashboardApiTrendWidget<Data>
            title="会员费用新增分析"
            load={value => dashboardService.getAddMemberRevenueAnalysis(value as never)}
            series={[
                { label: "基础会员费用", key: "totalBaseMemberCosts" },
                { label: "高级会员费用", key: "totalSeniorMemberCosts" },
                { label: "企业会员费用", key: "totalEnterpriseGradeMemberCosts" }
            ]}
        />
    );
}
